import { styled } from '@clickcease/cc-client-components-lib'

export const CrossSellStyled = styled('div', {
  display: 'flex',
  padding: '80px',
  height: 'calc(100% - 48px)',
  flexWrap: 'wrap',
  borderRadius: '$medium',
  justifyContent: 'space-between',
  background: 'linear-gradient(180deg, #FFF 0%, #EEF1FA 100%)',

  '@laptop': {
    padding: '30px',
  },
})

export const CrossSellWrapper = styled('div', { maxWidth: '1440px', margin: '0 auto' })

export const Divider = styled('div', {
  width: '100%',
  height: '1px',
  marginLeft: 'auto',
  marginRight: 'auto',
  background: '$heat3',
  marginTop: '$16',
  marginBottom: '$24',
})
